import PropTypes from 'prop-types';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from '@chakra-ui/react';

function FormikFormControl({
  label,
  helperText,
  errors,
  touched,
  children,
  ...rest
}) {
  return (
    <FormControl isInvalid={errors && touched} {...rest}>
      <FormLabel>{label}</FormLabel>
      {children}
      {errors && <FormErrorMessage>{errors}</FormErrorMessage>}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

FormikFormControl.defaultProps = {
  errors: null,
  touched: false,
  helperText: null,
};

FormikFormControl.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  helperText: PropTypes.string,
  errors: PropTypes.string,
  touched: PropTypes.bool,
};

export default FormikFormControl;
